import { Component, h, Prop } from '@stencil/core'

@Component({
    tag: 'zr-bannerx-cta',
    styleUrl: 'zr-bannerx-cta.scss',
    shadow: true,
})

/**
 * ZooRoyal Banner X Slider.
 */
export class ZrBannerxCta {

    @Prop() ctaText: string

    @Prop() ctaLink: string

    @Prop() ctaTextAccessibility: string

    /**
     * Element reference to the ctaTile.
     */
    private ctaTile: HTMLElement

    /**
     * Handle the focus event on the ctaTile.
     */
    private handleCtaTileFocus = () => {
        this.ctaTile.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }

    /**
     * Renders the component.
     */
    render() {
        return (
            <div class="zr-bannerx-cta__wrapper" ref={el => (this.ctaTile = el)}>
                <a
                    class="zr-bannerx-cta__tile"
                    aria-label={this.ctaTextAccessibility}
                    href={this.ctaLink}
                    onFocus={this.handleCtaTileFocus}
                    innerHTML={this.ctaText}
                />
            </div>
        )
    }
}
